import { useTranslation } from 'react-i18next';

import { Confirm, themes } from 'libs/ui';

export const ConfirmSetForm = (props) => {
  const { title, close, okTitle, working } = props;
  const { t } = useTranslation();

  const okTitleOk = okTitle ?? 'buttons.Подтвердить';

  /**
   * make action
   * @param {*} event
   */
  const action = (event) => {
    if (event) {
      event.preventDefault();
    }
    props.action();
  };

  return (
    <Confirm
      title={t('messages.' + title)}
      width="440px"
      type="danger"
      cancelButton={{ text: t('buttons.Отмена'), func: close }}
      acceptButton={{ text: t(okTitleOk), func: action, theme: themes.red }}
      working={working}
    />
  );
};
